// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const KeyValuePair = t.struct({
    key: t.String,
    value: t.String,
}, {
    name: 'KeyValuePair',
    strict: false,
});

export const getDefaultState = () => new KeyValuePair({
    key: '',
    value: '',
});

export default KeyValuePair;
